import {
  FormFieldsCategory,
  FormValues,
  SubscriberResponseDto,
  ExtendedFieldWithValueDto,
} from 'theSource/types';
import { mapFormValues, mapCategories } from 'theSource/utils';
import { SubscriberEditRequestDto } from '../types';

export const mapSubscriberEditDto = (
  categories: FormFieldsCategory[],
  values: FormValues
): SubscriberEditRequestDto => {
  const data = mapFormValues(categories, values);

  return {
    subscriber: data,
  };
};

export const mapSubscriberModel = (
  response: SubscriberResponseDto,
  originalFormFields: { [key: string]: string | null }
): FormFieldsCategory[] => {
  // only include fields defined in FORM_FIELDS
  const mappedFields = Object.entries(response.data)
    .filter(([key, _]) => key in originalFormFields)
    .map<ExtendedFieldWithValueDto>(([key, value]) => ({
      fieldName: key,
      ...value,
    }));

  // group by categories and map data
  const categories = mapCategories(mappedFields, originalFormFields);

  return categories;
};
